import React, { FC } from 'react'
import { useField, FormikProps } from 'formik'
import clsx from 'clsx'

import { ReactComponent as TooltipInfo } from 'assets/images/mini_tooltip.svg'
import { CloseCircleFilled } from '@ant-design/icons'

import { Switch, Checkbox, Tooltip } from '@pepper/ui'
import ComponentPicker from '../ComponentPicker'

import styles from './_.module.css'

interface Props {
  name: string
  label?: string
  required?: boolean
  values: {
    yes: string | number
    no: string | number
  }
  body?: IProjectBody[]
  actions: FormikProps<any>
  defaultStaticValue: string | number
  renderAsCheckbox?: boolean
  miniTooltip?: string
  disabled?: boolean
}

const SwitchView: FC<Props> = ({
  name,
  label,
  required,
  values,
  body,
  actions,
  renderAsCheckbox = false,
  miniTooltip,
  disabled,
}) => {
  const [field, meta, helpers] = useField(name)

  const updateValue = (val: boolean) => {
    if (val) {
      helpers.setValue(values.yes)
    } else {
      helpers.setValue(values.no)
    }
  }
  const checkIsSelected = () => {
    return field.value === values.yes
  }
  return (
    <>
      <div className={styles.switchWrap}>
        <div className={styles.headerWrap}>
          {renderAsCheckbox ? (
            <>
              <div className={styles.checkboxWrap}>
                <Checkbox
                  defaultChecked={field.value === values.yes}
                  className={clsx(styles.switchTag)}
                  onChange={event => updateValue(event?.target?.checked)}
                  disabled={disabled}
                />
              </div>
              <span className={styles.labelText}>{label}</span>
              {required && <span className={styles.requiredText}>*</span>}
              {miniTooltip && (
                <Tooltip
                  placement="top"
                  title={() => (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: miniTooltip,
                      }}
                    />
                  )}
                >
                  <TooltipInfo className={styles.tooltipPos} />
                </Tooltip>
              )}
            </>
          ) : (
            <>
              <span className={styles.labelText}>{label}</span>
              {required && <span className={styles.requiredText}>*</span>}
              <Switch
                defaultChecked={field.value === values.yes}
                className={clsx(styles.switchTag)}
                onChange={(checked: boolean) => updateValue(checked)}
                disabled={disabled}
              />
              {miniTooltip && (
                <Tooltip
                  placement="top"
                  title={() => (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: miniTooltip,
                      }}
                    />
                  )}
                >
                  <TooltipInfo className={styles.tooltipPos} />
                </Tooltip>
              )}
            </>
          )}
        </div>
        {meta.touched && meta.error ? (
          <div className={styles.error}>
            <CloseCircleFilled className={styles.errorIcon} /> {meta.error}
          </div>
        ) : null}
      </div>
      {checkIsSelected() &&
        body?.map((bodyItem, index) => {
          return (
            <ComponentPicker
              key={index}
              actions={actions}
              data={{ ...bodyItem, disabled }}
            />
          )
        })}
    </>
  )
}

export default SwitchView
